import React, { useRef, useState } from 'react';
import EmailEditor from 'react-email-editor';
import axios from 'axios';
import sample from "./sampleTemplate.json"
import { EmailEditorProps } from 'react-email-editor';
import Sidebar from "../Components/Sidebar/Sidebar";
import { editemaildata, getemaildatabyid } from "../Api/crm";


function EditEmail() {

    //get id from url email-builder-view/1
    const location = window.location.pathname.split("/")[2];

    const emailEditorRef = useRef(null);
    const [emailsubject, setEmailSubject] = useState('');
    const [emailsubjecterror, setEmailSubjectError] = useState(false);

    const onDesignLoad = (data) => {
        console.log('onDesignLoad', data);
    };


    const onLoad = (unlayer) => {
        console.log('onLoad', unlayer);
        unlayer.addEventListener('design:loaded', onDesignLoad);
        // unlayer.loadDesign(sample);

        const formData = new FormData();
        formData.append("email_id", window.location.pathname.split("/")[2]);
        getemaildatabyid(formData)
            .then((response) => {
                if (response.code === 200) {
                    const apiResponse = response.data;
                    if (apiResponse.status === 1) {
                        const fetchedMargedata = apiResponse.data;
                        const jsondata = JSON.parse(fetchedMargedata.json);
                        setEmailSubject(fetchedMargedata.subject);
                        unlayer.loadDesign(jsondata);
                    } else {
                    }
                }
            })
            .catch(function (err) {
                console.error("Error fetching data:", err);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });


    };

    const onReady = (unlayer) => {
        console.log('onReady', unlayer);
    };

    const [loading, setLoading] = React.useState(false);

    const exportHtml = () => {
        const unlayer = emailEditorRef.current?.editor;

        unlayer?.exportHtml((data) => {
            const { design, html } = data;
            //give me in json format
            // console.log('design', design);
            // console.log('exportHtml', html);

            if (emailsubject === '') {
                setEmailSubjectError(true);
                return;
            }

            setLoading(true);
            const formData = new FormData();
            formData.append("email_subject", emailsubject);
            formData.append("email_json", JSON.stringify(design));
            formData.append("email_html", html);
            formData.append("filename", window.location.pathname.split("/")[2]);
            editemaildata(formData)
                .then((response) => {
                    if (response.code === 200) {
                        const apiResponse = response.data;

                        // Check if the API status is success
                        if (apiResponse.status === 1) {
                            window.location.href = `/email-builder`
                        }
                    }
                })
                .catch(function (err) {
                    console.error("Error fetching data:", err);
                    setLoading(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };



    return (
        <div>

            <div className="dashboard-container d-flex">
                <div className="sidebar-container">
                    <Sidebar />
                </div>
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fulid">
                                    <div className="">
                                        <div className="table-card ">
                                            <div className="card-body table-card-body">
                                                <div className="table-card-header">
                                                    <h5 className="card-title">Email Builder</h5>
                                                </div>
                                                <div className="card-body">
                                                    <EmailEditor ref={emailEditorRef}
                                                        style={{ height: "100vh" }}
                                                        onLoad={onLoad}
                                                        onReady={onReady}
                                                        options={{
                                                            mergeTags: {
                                                                booking_date: { name: 'booking_date', value: '{{booking_date}}' },
                                                                booking_id: { name: 'booking_id', value: '{{booking_id}}' },
                                                                booking_time: { name: 'booking_time', value: '{{booking_time}}' },
                                                                service_name: { name: 'service_name', value: '{{service_name}}' },
                                                                client_name: { name: 'client_name', value: '{{client_name}}' },
                                                                methodname: { name: 'methodname', value: '{{methodname}}' },
                                                                units: { name: 'units', value: '{{units}}' },
                                                                addons: { name: 'addons', value: '{{addons}}' },
                                                                firstname: { name: 'firstname', value: '{{firstname}}' },
                                                                lastname: { name: 'lastname', value: '{{lastname}}' },
                                                                client_email: { name: 'client_email', value: '{{client_email}}' },
                                                                client_phone: { name: 'client_phone', value: '{{client_phone}}' },
                                                                special_instructions: { name: 'special_instructions', value: '{{special_instructions}}' },
                                                                price: { name: 'price', value: '{{price}}' },
                                                                client_address: { name: 'client_address', value: '{{client_address}}' },
                                                                client_city: { name: 'client_city', value: '{{client_city}}' },
                                                                client_state: { name: 'client_state', value: '{{client_state}}' },
                                                                business_logo: { name: 'business_logo', value: '{{business_logo}}' },
                                                                company_name: { name: 'company_name', value: '{{company_name}}' },
                                                                company_address: { name: 'company_address', value: '{{company_address}}' },
                                                                company_city: { name: 'company_city', value: '{{company_city}}' },
                                                                company_state: { name: 'company_state', value: '{{company_state}}' },
                                                                company_zip: { name: 'company_zip', value: '{{company_zip}}' },
                                                                company_country: { name: 'company_country', value: '{{company_country}}' },
                                                                company_phone: { name: 'company_phone', value: '{{company_phone}}' },
                                                                company_email: { name: 'company_email', value: '{{company_email}}' },
                                                                technitian_name: { name: 'technitian_name', value: '{{technitian_name}}' },
                                                                invoice_list: {name: 'invoice_list', value: '{{invoice_list}}'},
                                                            }
                                                        }}
                                                    />

                                                    <label className="form-label">Email Subject</label>
                                                    <input type="text" className="form-control" value={emailsubject} onChange={(e) => {
                                                        setEmailSubject(e.target.value);
                                                        setEmailSubjectError(false)
                                                    }} />
                                                    {

                                                        emailsubjecterror == true ? <p style={{ color: 'red' }}>Email subject is required</p> : ''
                                                    }
                                                    {
                                                        loading ? (<button className="btn setting-btn bg-green-dark" disabled>Saving...</button>) : (<button className="btn setting-btn bg-green-dark" onClick={exportHtml}>Update Template</button>)
                                                    }


                                                    <br />

                                                    <style>
                                                        {`
                                                            .blockbuilder-branding{
                                                                display: none !important;
                                                            }
                                                        }`}
                                                    </style>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default EditEmail;